import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Monday', value: '0' },
    { label: 'Tuesday', value: '1' },
    { label: 'Wednesday', value: '2' },
    { label: 'Thursday', value: '3' },
    { label: 'Friday', value: '4' },
    { label: 'Saturday', value: '5' },
    { label: 'Sunday', value: '6' },
]

export default function SelectWeekday({...props}) {

    const myProps = {
        placeholder: 'Select weekdays', label: 'Weekdays',
        firstSelect: true, isClearable: true, options: OPTIONS,
        icon: { icon: 'calendar-day' }, isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}